import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
@license
Copyright (c) 2019 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { ListMixin } from './vaadin-list-mixin.js';
/**
 * A mixin for `nav` elements, facilitating multiple selection of childNodes.
 *
 * @polymerMixin
 * @mixes Vaadin.ListMixin
 */

export var MultiSelectListMixin = function MultiSelectListMixin(superClass) {
  return (
    /*#__PURE__*/
    function (_ListMixin) {
      _inherits(VaadinMultiSelectListMixin, _ListMixin);

      function VaadinMultiSelectListMixin() {
        _classCallCheck(this, VaadinMultiSelectListMixin);

        return _possibleConstructorReturn(this, _getPrototypeOf(VaadinMultiSelectListMixin).apply(this, arguments));
      }

      _createClass(VaadinMultiSelectListMixin, [{
        key: "ready",
        value: function ready() {
          var _this = this;

          // Should be attached before click listener in list-mixin
          this.addEventListener('click', function (e) {
            return _this._onMultipleClick(e);
          });

          _get(_getPrototypeOf(VaadinMultiSelectListMixin.prototype), "ready", this).call(this);
        }
      }, {
        key: "_enhanceMultipleItems",
        value: function _enhanceMultipleItems(items, multiple, selected, selectedValues) {
          if (!items || !multiple) {
            return;
          }

          if (selectedValues) {
            var selectedItems = selectedValues.map(function (selectedId) {
              return items[selectedId];
            });
            items.forEach(function (item) {
              return item.selected = selectedItems.indexOf(item) !== -1;
            });
          }

          var lastSelectedItem = this.selectedValues.slice(-1)[0];

          if (lastSelectedItem && !lastSelectedItem.disabled) {
            this._scrollToItem(lastSelectedItem);
          }
        }
      }, {
        key: "_onMultipleClick",
        value: function _onMultipleClick(event) {
          var item = this._filterItems(event.composedPath())[0];

          var idx = item && !item.disabled ? this.items.indexOf(item) : -1;

          if (idx < 0 || !this.multiple) {
            return;
          }

          event.preventDefault();

          if (this.selectedValues.indexOf(idx) !== -1) {
            this.selectedValues = this.selectedValues.filter(function (v) {
              return v !== idx;
            });
          } else {
            this.selectedValues = this.selectedValues.concat(idx);
          }
        }
      }, {
        key: "_multipleChanged",
        value: function _multipleChanged(value, oldValue) {
          // Changing from multiple to single selection, clear selection.
          if (!value && oldValue) {
            this.selectedValues = [];
            this.items.forEach(function (item) {
              return item.selected = false;
            });
          } // Changing from single to multiple selection, add selected to selectedValues.


          if (value && !oldValue && this.selected !== undefined) {
            this.push('selectedValues', this.selected);
            this.selected = undefined;
          }
        }
        /**
         * Fired when the selection is changed.
         * Not fired in single selection mode.
         *
         * @event selected-values-changed
         * @param {Object} detail
         * @param {Object} detail.value the array of indexes of the items selected in the items array.
         */

      }], [{
        key: "properties",
        get: function get() {
          return {
            /**
             * Specifies that multiple options can be selected at once.
             */
            multiple: {
              type: Boolean,
              value: false,
              reflectToAttribute: true,
              observer: '_multipleChanged'
            },

            /**
             * Array of indexes of the items selected in the items array
             * Note: Not updated when used in single selection mode.
             */
            selectedValues: {
              type: Array,
              notify: true,
              value: function value() {
                return [];
              }
            }
          };
        }
      }, {
        key: "observers",
        get: function get() {
          return ["_enhanceMultipleItems(items, multiple, selected, selectedValues, selectedValues.*)"];
        }
      }]);

      return VaadinMultiSelectListMixin;
    }(ListMixin(superClass))
  );
};